import React from 'react';

import CircularLoading from '../Common/CircularLoading/CircularLoading';

class QuestionFavoritesButton extends React.Component {
  state = {};

  render() {
    return (
      <div>
        <div
          className={
            this.props.isFavorite
              ? `relevant-card favorite d-flex justify-content-${
                  this.props.loadFavoriteQuestion ? 'center' : 'between'
                } active `
              : `relevant-card favorite d-flex justify-content-${
                  this.props.loadFavoriteQuestion ? 'center' : 'between'
                }`
          }
          onClick={() => {
            this.props.toggleFavorite(!this.props.isFavorite);
          }}
          data-test="question-to-my-favorites-button"
        >
          <span className={this.props.isFavorite ? 'color-favorite' : ''}>
            {this.props.isFavorite
              ? 'Remove question from my favorites'
              : 'Save question to my favorites'}
          </span>
          {!this.props.loadFavoriteQuestion ? (
            <i
              className={
                this.props.isFavorite
                  ? 'icon-star_border color-favorite'
                  : 'icon-star_border'
              }
            />
          ) : (
            <CircularLoading
              className="loading-gif-waiting"
              height="20"
              width="20"
            />
          )}
        </div>
      </div>
    );
  }
}

export default QuestionFavoritesButton;
